import React from 'react';
import PropTypes from 'prop-types';
import Button from '@zg-rentals/multibrand-ui/lib/Button';

export default class InquiryInAction extends React.Component {
    static propTypes = {
        onSelectAction: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.handleOnClickCall = this.handleOnClick.bind(this, 'call');
        this.handleOnClickSMS = this.handleOnClick.bind(this, 'sms');
    }

    handleOnClick(action) {
        const { onSelectAction } = this.props;

        onSelectAction(action);
    }

    render() {
        return (
            <div className="Inquiry-contact-buttons inline-children-sm">
                <Button onClick={this.handleOnClickCall} type="tertiary">
                    Call
                </Button>
                <Button onClick={this.handleOnClickSMS} type="tertiary">
                    SMS
                </Button>
            </div>
        );
    }
}
